import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VerifyStep = ({
  children,
  button,
  borderBottom = false
}) => /*#__PURE__*/_jsx(View, {
  padding: "600",
  borderStyle: "solid",
  borderWidth: "100",
  borderBlockEndWidth: borderBottom ? '100' : '0',
  textAlign: "start",
  borderColor: "border-core-subtle",
  children: /*#__PURE__*/_jsxs(TFlex, {
    justify: "between",
    align: "center",
    children: [children, /*#__PURE__*/_jsx(View, {
      marginInlineStart: "400",
      as: "div",
      children: button
    })]
  })
});
VerifyStep.displayName = 'VerifyStep';
export default VerifyStep;